
import Consts from '../Consts';

const scaleArray = (array) => {
  return array.map(v => {
    return new ClipperLib.IntPoint(v.X * Consts.BOOLEAN_SCALE, v.Y * Consts.BOOLEAN_SCALE);
  });
};

const scaleBooleanInput = (input) => {
  return input.map(nested => {
    if (nested.length > 0 && nested[0] instanceof Array) {
      // 2D
      return nested.map(array => {
        return scaleArray(array);
      });
    }
    // 1D
    return scaleArray(nested);
  });
};

const rescaleBooleanOutput = (solution) => {
  return solution.map(path => {
    return path.map(p => {
      return new ClipperLib.DoublePoint(p.X / Consts.BOOLEAN_SCALE, p.Y / Consts.BOOLEAN_SCALE);
    });
  });
};

const rescaleBooleanOutput2 = (solution) => {
  return solution.map(path1 => {
    return path1.map(path2 => {
      return path2.map(p => {
        return new ClipperLib.DoublePoint(p.X / Consts.BOOLEAN_SCALE, p.Y / Consts.BOOLEAN_SCALE);
      });
    });
  });
};

export {
  scaleBooleanInput,
  rescaleBooleanOutput,
  rescaleBooleanOutput2
};



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/GHBooleanUtils.js